import { Center, FormControl, FormLabel, Spinner, Switch, Text } from '@chakra-ui/react';
import { trpcAdmin } from '../../lib/trpcAdmin';
import { testIds } from '../testIds';

export function EmployerCoursesToggleList({
  selectedIds,
  onChange,
}: {
  selectedIds: Set<string>;
  onChange: (ids: Set<string>) => void;
}): React.ReactElement {
  const { data: courses = [], isLoading } =
    trpcAdmin.workPlacements.employers.listWorkPlacementCourses.useQuery();

  const toggle = (id: string) => {
    const next = new Set(selectedIds);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    onChange(next);
  };

  if (isLoading) {
    return (
      <Center p={8}>
        <Spinner />
      </Center>
    );
  }

  return (
    <>
      {courses.map((course) => (
        <FormControl
          key={course.id}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <FormLabel htmlFor={`course-${course.id}`} mb={0} fontWeight="normal">
            <Text as="span" fontWeight="semibold">
              {course.identifier}
            </Text>{' '}
            <Text as="span" color="fg.subtle">
              {course.title}
            </Text>
          </FormLabel>
          <Switch
            id={`course-${course.id}`}
            colorScheme="brand"
            isChecked={selectedIds.has(course.id)}
            onChange={() => toggle(course.id)}
            data-testid={testIds.courseToggle}
          />
        </FormControl>
      ))}
    </>
  );
}
